module.exports = __webpack_public_path__ + "public/images/stand-v.f0d9faa6e637a6843aa3b1beb348f0be.svg";